module.exports = __webpack_public_path__ + "static/media/MHSB999.e8be4765.png";